'use client';

import { Button as RACButton, ButtonProps as RACButtonProps } from 'react-aria-components';

import { cn } from '../../utils/css/cn';

const variantStyles = {
	primary: [
		'inline-flex items-center justify-center cursor-pointer',
		'text-white bg-takeda-dark-red-600',
		'border border-takeda-dark-red-600',
		'min-w-50 px-8 py-[13px]',
		'leading-5 font-medium uppercase text-center',

		'hover:bg-takeda-dark-red-800 hover:border-takeda-dark-red-800',
		'active:bg-takeda-dark-red-700 active:border-takeda-dark-red-700',
		'focus-visible:outline-none data-focus-visible:outline-solid data-focus-visible:outline-2 data-focus-visible:outline-offset-2 data-focus-visible:outline-takeda-dark-red-600 data-focus-visible:bg-takeda-dark-red-800 data-focus-visible:border-takeda-dark-red-800',
		'disabled:cursor-default disabled:bg-takeda-light-grey-600 disabled:text-takeda-medium-grey-600 disabled:border-takeda-light-grey-600',

		// no dark theme for primary button
	],

	secondary: [
		'inline-flex items-center justify-center cursor-pointer',
		'text-takeda-dark-red-600 bg-white',
		'border border-takeda-dark-red-600',
		'min-w-50 px-8 py-[13px]',
		'leading-5 font-medium uppercase text-center',

		'hover:border-takeda-dark-red-800 hover:text-takeda-dark-red-800',
		'active:border-takeda-dark-red-700 active:text-takeda-dark-red-700',
		'focus-visible:outline-none data-focus-visible:outline-solid data-focus-visible:outline-2 data-focus-visible:outline-offset-2 data-focus-visible:outline-takeda-dark-red-600 data-focus-visible:text-takeda-dark-red-800 data-focus-visible:border-takeda-dark-red-800',
		'disabled:cursor-default disabled:bg-white disabled:border-takeda-medium-grey-600 disabled:text-takeda-medium-grey-600',

		'dark:text-white dark:border-white dark:bg-inherit',
		'dark:hover:text-white dark:hover:bg-takeda-medium-grey-800 dark:hover:border-takeda-medium-grey-800',
		'dark:active:bg-takeda-medium-grey-600 dark:active:border-takeda-medium-grey-600',
		'dark:focus-visible:outline-white dark:focus-visible:text-white dark:focus-visible:border-takeda-medium-grey-800 dark:focus-visible:bg-takeda-medium-grey-800',
		'dark:disabled:bg-inherit dark:disabled:border-takeda-medium-grey-600 dark:disabled:text-takeda-medium-grey-600',
	],

	text: [
		'inline-flex items-center justify-center cursor-pointer',
		'text-takeda-dark-red-600',
		'border border-transparent',
		'min-w-50 px-8 py-[13px]',
		'leading-5 font-medium uppercase text-center',

		'hover:border-b-takeda-dark-red-800 hover:text-takeda-dark-red-800',
		'active:text-takeda-dark-red-700',
		'focus-visible:outline-none data-focus-visible:outline-solid data-focus-visible:outline-2 data-focus-visible:outline-offset-2 data-focus-visible:outline-takeda-dark-red-600 data-focus-visible:text-takeda-dark-red-800',
		'disabled:text-takeda-medium-grey-600 disabled:cursor-default disabled:border-b-transparent',

		'dark:text-white',
		'dark:hover:text-white dark:hover:border-b-white',
		'dark:active:text-takeda-medium-grey-300 dark:active:border-b-takeda-medium-grey-300',
		'dark:data-focus-visible:outline-white dark:data-focus-visible:text-white',
		'dark:disabled:text-takeda-medium-grey-600 dark:disabled:border-b-transparent',
	],
};

interface ButtonProps extends RACButtonProps {
	variant?: keyof typeof variantStyles;
}

export const Button = ({ className, children, variant = 'primary', ...props }: ButtonProps) => {
	return (
		<RACButton {...props} className={cn(variantStyles[variant], className)}>
			{children}
		</RACButton>
	);
};
